export default "__VITE_ASSET__CXWzpWUr__"